import React, { useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import { IconChevronRight } from '@prisjakt/ui/icon';
import { ButtonIcon } from '@prisjakt/ui/button';
import { ButtonText } from '@prisjakt/ui/button/variants';
import { StoreLink, LinkDesktop, LinkMobile } from './styles';

type Props = {
  className?: string;
  isAlternative?: boolean;
};

export const GoToStoreButton: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<Props>
>> = props => {
  const { className } = props;

  const { t } = useContext(AppContext);

  return (
    <StoreLink className={className} data-test="GoToStoreButton">
      <LinkDesktop ariaLabel={t('product', 'store.link')} tabIndex={-1}>
        <ButtonText>{t('product', 'store.link')}</ButtonText>
        <ButtonIcon>
          <IconChevronRight />
        </ButtonIcon>
      </LinkDesktop>

      <LinkMobile>
        <IconChevronRight color="maybeBlue500" size={24} />
      </LinkMobile>
    </StoreLink>
  );
};
